import { render, staticRenderFns } from "./CEventTeaser.vue?vue&type=template&id=62759d8c&"
import script from "./CEventTeaser.vue?vue&type=script&lang=js&"
export * from "./CEventTeaser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports